import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { INSTAGRAM_URL, InstagramIcon, LOGO_BLANCO } from '../landing/brand';
import { CALCULADORAS, PRECIOS, SITIO } from '../landing/publicLinks';
import { yaIngresoEnEsteDispositivo } from '../../helpers/ctaPublico';
import useContacto from '../landing/useContacto';

// Pie de todo el sitio público (manual de marca v1.0). Linkea a todas las
// herramientas gratis y páginas públicas: además de servirle al visitante,
// es como Google las encuentra y las relaciona entre sí.

const PublicFooter: React.FC = () => {
  const { user } = useAuth();
  const contacto = useContacto();

  return (
    <footer className="lp-scope lp-foot">
      <div className="lp-wrap lp-foot__grid">
        <div className="lp-foot__brand">
          <img src={LOGO_BLANCO} alt="MiCampoDigital" width={146} height={36} />
          <p>Gestión ganadera para productores argentinos. Crear la cuenta es gratis y sin tarjeta.</p>
        </div>

        <nav aria-label="Herramientas gratis">
          <p className="lp-foot__h">Herramientas gratis</p>
          {[...PRECIOS, ...CALCULADORAS].map(({ to, label }) => (
            <Link key={to} to={to}>
              {label}
            </Link>
          ))}
        </nav>

        <nav aria-label="MiCampoDigital">
          <p className="lp-foot__h">MiCampoDigital</p>
          {SITIO.map(({ to, label }) => (
            <Link key={to} to={to}>
              {label}
            </Link>
          ))}
          {user ? (
            <Link to="/dashboard">Mi panel</Link>
          ) : yaIngresoEnEsteDispositivo() ? (
            <Link to="/login">Ingresar</Link>
          ) : (
            <Link to="/login?mode=signup">Creá tu cuenta</Link>
          )}
        </nav>

        <nav aria-label="Contacto">
          <p className="lp-foot__h">Contacto</p>
          <button type="button" onClick={contacto} title="Hablar con atención al cliente">
            Escribinos
          </button>
          <a className="lp-foot__ig" href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
            <InstagramIcon /> @micampodigital
          </a>
        </nav>
      </div>
      <div className="lp-wrap lp-foot__bottom">
        <span>© {new Date().getFullYear()} MiCampoDigital</span>
      </div>
    </footer>
  );
};

export default PublicFooter;
